import { Link } from 'react-router-dom';

import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function URLEntityFormatter({ info, url, entities }) {
  const { value: entityId } = getInfo(info)

  if (!entityId) {
    return '--'
  }

  const entity = entities[entityId]

  return <>
    <Link to={`${url}/${entityId}`} className='twy-text-base-accent hover:underline'>
      {`[#${entityId}] - ${entity || entityId}`}
    </Link>
  </>
}
